import React from "react";
import Footer from "../../Public/Footer/Footer";
import Div100vh from "react-div-100vh";
import useWindowSize from "../../../core/hooks/useWindowSize";
import { isMobile } from "react-device-detect";
import { AwaitingDialogContextProvider } from "../../../core/contexts/AwaitingDialogContext";

function MapWrapper(props) {
  const windowSize = useWindowSize();

  const getStyle = () => {
    //alert(windowSize.height);
    if (!isMobile) {
      return null;
    }

    return {
      minHeight: windowSize.height - 70,
    };
  };

  return (
    <Div100vh>
      <AwaitingDialogContextProvider>
        <div className="main-panel">
          {props.header}

          <div className="content map-wrapper" style={getStyle()}>
            {props.children}

            <Footer />
          </div>
        </div>
      </AwaitingDialogContextProvider>
    </Div100vh>
  );
}

export default MapWrapper;
